module.exports = __webpack_public_path__ + "img/Crane_Logo.aca8dac9.png";